import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=70cc33b0&scoped=true&"
import script from "./PurchaseList.vue?vue&type=script&lang=js&"
export * from "./PurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=70cc33b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc33b0",
  null
  
)

export default component.exports